import frustumCull from '../frustumCull'

export default `
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;

uniform vec3 uBgColor;
uniform vec3 uInnerShadowColor;
uniform vec3 uInnerShadowColor2;
uniform vec4 uRectData;
uniform vec4 uProgress;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;

void main(){
  float sx = abs(vNormal.x);
  float sy = abs(vNormal.y);
  float sz = abs(vNormal.z);
  vec3 color = uColor1;
  vec3 white = vec3(1.0);

  vec2 f = vec2(0.2, 0.9);
  vec3 i = smoothstep(f.x, f.y, abs(vPosition));
  i = 1.0 - pow(i, vec3(2.0));

  float innerShadowX = pow(i.y * i.z, 2.0);
  float innerShadowY = pow(i.x * i.z, 2.0);
  float innerShadowZ = pow(i.x * i.y, 2.0);


  vec3 colorX = vec3(0.0);
  vec3 colorY = vec3(0.0);
  vec3 colorZ = vec3(0.0);

  vec3 color1 = mix(pow(uColor1, vec3(1.5)) * 0.7, uColor1, vPosition.z + 0.5);


  colorX = mix(uColor1, uColor3, smoothstep(-0.3, 1.0, vPosition.y + 0.5));
  colorY = mix(uInnerShadowColor2, uColor2, innerShadowY);
  colorZ = mix(uColor1, uColor3, smoothstep(-0.3, 1.0, vPosition.y + 0.5));


  float faceYFactor = (1.0 - smoothstep(0.7, 0.75, sy));
  float faceZFactor = (1.0 - smoothstep(0.7, 0.75, sz));

  color = mix(colorY, colorX, faceYFactor);
  color = mix(colorZ, color, faceZFactor);

  float l = dot(normalize(vec3(-1, 0, 0)), vNormal2) * 0.5 + 0.5;
  color = mix(color * 0.7, color, l);


  gl_FragColor = vec4(color, 1.0);

  #ifndef IS_GLASS_RENDER
  ${frustumCull}
  #endif

  gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.0/2.2));
  gl_FragColor.rgb = mix(uBgColor, gl_FragColor.rgb, uProgress.x);
}
`
